function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 47.9366V32.0633C10 26.7233 12.84 21.7866 17.4533 19.1L32.4533 10.37C37.1167 7.65663 42.88 7.65663 47.5433 10.37L62.5433 19.1C67.16 21.7866 70 26.7233 70 32.0633V47.9366C70 53.2766 67.16 58.2133 62.5467 60.9L47.5467 69.63C42.8833 72.3433 37.12 72.3433 32.4567 69.63L17.4567 60.9C12.84 58.2133 10 53.2766 10 47.9366Z",
  fill: "#07C604"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4413 15.6428L15.4403 15.6434C9.59752 19.0461 6 25.2987 6 32.0633V47.9366C6 54.7015 9.59785 60.9545 15.4446 64.3571C15.4447 64.3571 15.4447 64.3571 15.4448 64.3572L30.4446 73.0871L30.445 73.0873C36.3519 76.5242 43.6515 76.5242 49.5583 73.0873L49.5587 73.0871L64.5587 64.3571L64.5597 64.3565C70.4025 60.9539 74 54.7012 74 47.9366V32.0633C74 25.2984 70.4022 19.0454 64.5554 15.6428C64.5553 15.6428 64.5553 15.6428 64.5552 15.6428L49.5554 6.91284L49.555 6.91261C43.6481 3.47575 36.3485 3.47575 30.4417 6.91261L30.4413 6.91284L15.4413 15.6428Z",
  stroke: "#07C604",
  strokeOpacity: 0.1,
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.3332 31.667L36.6665 48.3337L26.6665 38.3337",
  stroke: "#E2FDE2",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgDoneGreen = function SvgDoneGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoneGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done-green.4ad38630.svg";
export { ForwardRef as ReactComponent };